import React, { useContext, useState, useEffect } from 'react'
import { graphql } from 'gatsby'

import { LangContext } from 'context'
import { DEFAULT_LANG } from 'config/languages'
import { updateListSlugs } from 'utils/helpers'
import { Container, Row, Column } from 'components/Grid'
import PaginatedPostsList from 'components/PaginatedPostsList'
import Sidebar from 'components/Sidebar'

import { Section } from './styles'

export default function PostsList({
   cta,
   posts,
   writingPosts,
   podcastPosts,
   videoPosts,
   featuredPosts,
   categories = [],
   path,
   pagination,
   category,
}) {
   const [isOpen, handleIsOpen] = useState(false)
   const { lang } = useContext(LangContext)
   const langPrefix = lang === DEFAULT_LANG ? '/' : `/${lang}/`
   const updatedPosts = updateListSlugs(posts, langPrefix)
   const updatedWritingPosts = category === 'writing' ? [] : updateListSlugs(writingPosts, langPrefix)
   const updatedVideoPosts = category === 'videos' ? [] : updateListSlugs(videoPosts, langPrefix)
   const updatedPodcastPosts = category === 'podcasts' ? [] : updateListSlugs(podcastPosts, langPrefix)
   const updatedFeaturedPosts = category === 'featured' ? [] : updateListSlugs(featuredPosts, langPrefix)

   const labels = Object.assign(
      {},
      ...categories.map(({ node }) => {
         if (category && node.categoryName === 'featured') {
            const targetCategory = categories.find((item) => item.node.categoryName === category)
            return {
               [node.categoryName]: {
                  url: `${langPrefix}${node.categoryName}/`,
                  label: `${node.categoryLabel} ${targetCategory.node.categoryLabel}`,
               },
            }
         }
         return {
            [node.categoryName]: {
               url: `${langPrefix}${node.categoryName}/`,
               label: node.categoryLabel,
            },
         }
      })
   )

   const postLists = {
      featured: {
         category: labels.featured,
         posts: updatedFeaturedPosts,
      },
      writing: {
         category: labels.writing,
         posts: updatedWritingPosts,
      },
      video: {
         category: labels.videos,
         posts: updatedVideoPosts,
      },
      podcast: {
         category: labels.podcasts,
         posts: updatedPodcastPosts,
      },
   }

   useEffect(() => {
      handleIsOpen(true)
   }, [])

   return (
      <Section>
         <Container>
            <Row justifyContent={['space-between']}>
               <Column width={[1, 1, 1, 6 / 10]} order={[2, 2, 2, 1]}>
                  <PaginatedPostsList
                     list={updatedPosts}
                     fullWidth={true}
                     pagination={pagination}
                     path={path}
                     isOpen={isOpen}
                  />
               </Column>

               <Column width={[1, 1, 1, 4 / 10]} pl={[10, 10, 10, '24px']} order={[1, 1, 1, 2]}>
                  <Sidebar cta={cta} lists={postLists} isAnimated={isOpen} />
               </Column>
            </Row>
         </Container>
      </Section>
   )
}

export const query = graphql`
   fragment PostsList on ContentfulComponentPostsList {
      id
      cta {
         ...SubscriberBox
      }
   }
`
